import { jsx as _jsx } from "react/jsx-runtime";
import { createStyles, makeStyles } from "@mui/styles";
import { MealOptionView } from ".";
import { MacrosSummaryLabel } from "../../Macros/SummaryLabel";
import { getServingAmountsMacros } from "../../ServingAmount/utils";
const useStyles = makeStyles((theme) => createStyles({
    targets: {
        marginTop: theme.spacing(),
        textAlign: "center",
    },
}));
export const MealOptionViewMacro = ({ mealOption, displayMacros, footer, className }) => {
    const classes = useStyles();
    return (_jsx(MealOptionView, { mealOption: mealOption, className: className, targets: !displayMacros ? undefined : (_jsx("div", { className: classes.targets, children: _jsx(MacrosSummaryLabel, { macros: getServingAmountsMacros(mealOption.servingAmounts), variant: "sm", kcalPrefix: true }) })), footer: footer }));
};
//# sourceMappingURL=Macro.js.map